import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

const EMOJI_PATTERN =
  /(\p{Extended_Pictographic}|\p{Emoji_Modifier}|\p{Regional_Indicator})(️|‍(\p{Extended_Pictographic}|\p{Emoji_Modifier}|\p{Regional_Indicator}))*|[0-9#*]️?⃣/gu;

@Directive({
  selector: '[sharedNoEmoji]',
})
export class NoEmojiDirective {
  constructor(
    private _elementRef: ElementRef<HTMLInputElement | HTMLTextAreaElement>,
    @Optional() private _ngControl: NgControl
  ) {}

  @HostListener('input')
  public onInput(): void {
    this.stripEmoji();
  }

  @HostListener('paste')
  public onPaste(): void {
    setTimeout(() => this.stripEmoji(), 0);
  }

  private stripEmoji(): void {
    const input = this._elementRef.nativeElement;
    const raw = input.value;
    const clean = raw.replace(EMOJI_PATTERN, '');

    if (clean === raw) return;

    const caret = input.selectionStart ?? raw.length;
    const beforeCaretRaw = raw.slice(0, caret);
    const beforeCaretClean = beforeCaretRaw.replace(EMOJI_PATTERN, '');
    const removedBeforeCaret = beforeCaretRaw.length - beforeCaretClean.length;
    const newCaret = Math.max(0, caret - removedBeforeCaret);

    input.value = clean;
    this._ngControl?.control?.setValue(clean, { emitEvent: false });

    input.setSelectionRange(newCaret, newCaret);
  }
}
